import React from 'react';
import { Button, message, Form, Input } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useMutation } from '@apollo/client';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import modal from '~components/modal';
import { MUTATION_EDIT_NOTES } from '~pages/dashboard/reconciliation/booking-details/edit-notes/queries';

function EditNotes({ opportunityDetail, onClose, onConfirm, form, value }) {
  const { t } = useTranslation();
  const { getFieldDecorator } = form;

  const [
    upsertOpportunityReconciliationNote,
    { loading: upsertOpportunityReconciliationNoteLoading },
  ] = useMutation(MUTATION_EDIT_NOTES, {
    onError: e => {
      message.error(e.message);
    },
  });

  const handleSubmit = async () => {
    form.validateFieldsAndScroll(async err => {
      if (err) {
        message.warn(t('cms.reconciliation.booking.invoice_editor.submit.error'));
        return;
      }
      const formData = form.getFieldsValue();
      const reconciliationNote = formData.notes;
      if (reconciliationNote) {
        console.log(formData, 'formData');
        const response = await upsertOpportunityReconciliationNote({
          variables: {
            input: {
              opportunityId: opportunityDetail?.id,
              data: {
                reconciliationNote,
              },
            },
          },
        });

        if (response?.data?.upsertOpportunityReconciliationNote?.result) {
          message.success('Supply team notes successfully updated.');
          onConfirm();
          onClose();
        }
      }
    });
  };

  return (
    <div className="partner-register-city-editor invoice-editor">
      <div className="partner-register-city-editor__header invoice-editor__header">
        Edit supply team notes
        <CloseOutlined className="partner-register-city-editor__close-button" onClick={onClose} />
      </div>
      <div className="partner-register-city-editor__body">
        <section className="partner-reassign-editor__section partner-register-city-editor__main">
          <main className="partner-reassign-editor__main invoice-editor__form">
            <div className={classNames('partner-reassign-editor__form-item')}>
              <h3 className="partner-reassign-editor__selector-title" style={{ fontSize: '14px' }}>
                {t('cms.reconciliation.list.table.supply_team_notes')}:
              </h3>
              <Form.Item required={false}>
                {getFieldDecorator(`notes`, {
                  initialValue: value,
                })(<Input.TextArea maxLength={300} placeholder="...some information here" />)}
              </Form.Item>
            </div>
          </main>
        </section>
      </div>
      <div className="partner-register-city-editor__footer">
        <Button
          size="large"
          className="partner-register-city-editor__cancel-button"
          onClick={onClose}
        >
          {t('cms.referral.partner.detail.editor.btn.cancel')}
        </Button>
        <Button
          type="primary"
          size="large"
          className="partner-register-city-editor__save-button"
          loading={upsertOpportunityReconciliationNoteLoading}
          onClick={handleSubmit}
        >
          {t('cms.referral.partner.detail.editor.btn.save')}
        </Button>
      </div>
    </div>
  );
}

EditNotes.propTypes = {
  onClose: PropTypes.func.isRequired,
  value: PropTypes.string,
};

EditNotes.defaultProps = {
  onClose: () => {},
  value: null,
};

export default Form.create()(
  modal(
    {
      className: 'partner-register-city-editor-modal',
    },
    true,
  )(EditNotes),
);
